<template>
  <span v-html="svgContent" :class="['icon', icon]"></span>
</template>

<script>
import icons from "@/assets/icon/svgs.js";

export default {
  name: "SvgIcon",
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
  computed: {
    svgContent() {
      return icons[this.icon] || "";
    },
  },
};
</script>

<style scoped>
.icon {
  display: inline-block;
  fill: currentColor;
  display: inline-flex;
  align-items: center;
}
</style>
